export interface ListTreatmentAutoAssignJobsParams {
    readonly treatmentId?: string | null;
    readonly status?: string | null;
    readonly skipReason?: string | null;
    readonly from?: string | null;
    readonly to?: string | null;
    readonly page?: number | null;
    readonly pageSize?: number | null;
}
